import { render, staticRenderFns } from "./AgreementText.vue?vue&type=template&id=0a42d482&scoped=true&"
import script from "./AgreementText.vue?vue&type=script&lang=js&"
export * from "./AgreementText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a42d482",
  null
  
)

export default component.exports